import ScottImage from "../../assets/press/Scott.jpg";
import LogLugImage from "../../assets/press/LogLug.jpg";
import JaredImage from "../../assets/press/Jared.jpg";

export const creators = [
    {
        id: 3,
        name: 'Jared Christopher',
        role: 'Webmaster',
        linkedin: 'https://www.linkedin.com/in/jaredchristopher/',
        image: JaredImage
    },

    {
        id: 1,
        name: 'Scott DeLozier',
        role: 'Director',
        linkedin: 'https://www.linkedin.com/in/scott-delozier-3a17a8209/',
        image: ScottImage
    },

    {
        id: 2,
        name: 'Camden McKay',
        role: 'Webmaster',
        linkedin: 'https://www.linkedin.com/in/camden-mckay-a3140b251/',
        image: LogLugImage
    }


    //Simran Social Media, Cam, and Edward
    //Registration Coordinator 
    //Meal Captain Matthew
];